var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.settleProof.innerNo || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.settleProof.buyerRealComCode || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.settleProof.buyerPrftCenterCode || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.settleProof.buyerInnerSellerCode))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.settleProof.invoiceAmount != null
              ? _c("span", [
                  _vm._v(_vm._s(_vm.settleProof.invoiceAmount.toFixed(2)))
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.settleProof.invoiceFinished ? "是" : "否"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.settleProof.settleAmount != null
              ? _c("span", [
                  _vm._v(_vm._s(_vm.settleProof.settleAmount.toFixed(2)))
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.settleProof.paymentAmount != null
              ? _c("span", [
                  _vm._v(_vm._s(_vm.settleProof.paymentAmount.toFixed(2)))
                ])
              : _c("span", [_vm._v("0.00")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  (
                    (_vm.settleProof.settleAmount || 0.0) -
                    (_vm.settleProof.paymentAmount || 0.0)
                  ).toFixed(2)
                )
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("发票信息")]),
        _vm._v(" "),
        _vm.settleProof.settleChannelId == -1 &&
        !_vm.settleProof.invalid &&
        parseFloat(_vm.settleProof.settleAmount) > 0 &&
        !_vm.settleProof.invoiceFinished &&
        (_vm.settleProof.pullBackNo == null || _vm.settleProof.pullBackNo == "")
          ? _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-mini fr",
                on: {
                  click: function($event) {
                    _vm.applyInvoice(false)
                  }
                }
              },
              [_vm._v("登记发票")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.settleProof.settleChannelId == -1 &&
        !_vm.settleProof.invalid &&
        parseFloat(_vm.settleProof.settleAmount) > 0 &&
        !_vm.settleProof.invoiceFinished &&
        (_vm.settleProof.pullBackNo == null || _vm.settleProof.pullBackNo == "")
          ? _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-mini fr mr5",
                on: {
                  click: function($event) {
                    _vm.relInvoice()
                  }
                }
              },
              [_vm._v("关联发票")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.settleInvoiceItems, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "actualNo", label: "发票号", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "actualCode", label: "发票代码", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "amount",
              label: "含税金额(元)",
              width: "150",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.actualAmount != null
                      ? _c("span", [
                          _vm._v(_vm._s(rows.row.actualAmount.toFixed(2)))
                        ])
                      : _c("span", [_vm._v("0.00")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ntxAmount",
              label: "未税金额(元)",
              width: "150",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.actualNtxAmount != null
                      ? _c("span", [
                          _vm._v(_vm._s(rows.row.actualNtxAmount.toFixed(2)))
                        ])
                      : _c("span", [_vm._v("0.00")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "actualTaxAmount",
              label: "税额(元)",
              width: "150",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.actualTaxAmount != null
                      ? _c("span", [
                          _vm._v(_vm._s(rows.row.actualTaxAmount.toFixed(2)))
                        ])
                      : _c("span", [_vm._v("0.00")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "taxRate",
              label: "税率(%)",
              width: "150",
              align: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.taxRate != null
                      ? _c("span", [
                          _vm._v(_vm._s(rows.row.taxRate.toFixed(2)))
                        ])
                      : _c("span", [_vm._v("0.00")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ts",
              label: "开票日期",
              width: "160",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.showInvoiceVoucher(rows.row.invoiceVoucherId)
                          }
                        }
                      },
                      [_vm._v("详情")]
                    ),
                    _vm._v(" "),
                    _vm.settleProof.applyState != 1 &&
                    _vm.settleProof.auditState != 1
                      ? _c(
                          "span",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeInvoiceRel(rows.row.id)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("结算单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("买家公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("利润中心编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方内部标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已开发票金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("开票完毕")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算总金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已结算金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("未结算金额(元)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cff83a40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cff83a40","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/invoiceVoucher/SettltProofInvoiceVoucherInfo.vue
// module id = 2724
// module chunks = 0